module.exports = __webpack_public_path__ + "img/fzzl1-1_en.f85748a3.jpg";